export default __webpack_public_path__ + "static/media/memberBg1.fd8816bf.png";